const mission = [
    {            
        text: "Mission"
    },
    {            
        text: "Services"
    },
    {            
        text: "Case Studies"
    },
    {            
        text: "Contact"
    }  
]

export default mission
